import React from "react";
import { View, Text, TextInput, TouchableOpacity, Image, ScrollView } from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { CommonButton } from "../../../../common/CommonButton";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const CancelEventReason = ({
  selectReasonDropdown,
  setSelectReasonDropdown,
  selectedReason,
  setSelectedReason,
  customReason,
  setCustomReason,
  message,
  setMessage,
  isMobile = false,
  showMessageError = false,
}) => {
  const reasons = [
    "Scheduling Conflict",
    "Technical Issues",
    "Personal Reasons",
    "Unforeseen Circumstances",
    "Low Ticket Sales",
    "Other",
  ];
  const deviceSize = useDeviceSize();

  return (
    <View
      style={{
        width: isMobile ? "100%" : "55%",
        marginTop: isMobile ? 20 : 0,
        flex: 1,
      }}
    >
      {/* Title - only show on web */}
      {!isMobile && (
        <>
          <Text style={{
            ...AppFontStyle.BOLD_ANYBODY_24,
            color: "#FFFFFF",
            fontSize: 24,
          }}>
            Cancel Event
          </Text>
          <View
            style={{
              height: 1,
              backgroundColor: "#374151",
              marginVertical: 20,
            }}
          />
        </>
      )}

      {/* Why are you cancelling */}
      <View style={{ marginBottom: 20 }}>
        <Text style={{
          ...AppFontStyle.BOLD_ANYBODY_16,
          color: "#FFFFFF",
          marginBottom: 12,
        }}>
          Why are you cancelling the event?
        </Text>

        {/* Dropdown button */}
        <TouchableOpacity
          onPress={() => setSelectReasonDropdown(!selectReasonDropdown)}
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: 45,
            paddingHorizontal: 24,
            backgroundColor: "#1F2937",
            borderRadius: 8,
            borderWidth: 0.8,
            borderColor: "#374151",
          }}
        >
          <Text style={{
            ...AppFontStyle.BOLD_ANYBODY_14,
            color: "#FFFFFF",
            flex: 1,
            textAlign: "center",
          }}>
            {selectedReason || "Select Reason"}
          </Text>
          <Image
            source={AppImages.icDownLineArrow}
            style={{
              width: 16,
              height: 8,
              tintColor: "#FFFFFF",
              transform: [{ rotate: selectReasonDropdown ? "180deg" : "0deg" }],
            }}
            resizeMode="contain"
          />
        </TouchableOpacity>

        {/* Dropdown options - inline with scroll */}
        {selectReasonDropdown && (
          <View style={{
            marginTop: 8,
            height: 180,
            backgroundColor: "#111827",
            borderRadius: 8,
            borderWidth: 0.8,
            borderColor: "#374151",
            overflow: "hidden",
          }}>
            <ScrollView
              nestedScrollEnabled={true}
              showsVerticalScrollIndicator={true}
              style={{ height: 180 }}
            >
              {reasons.map((item, index) => (
                <TouchableOpacity
                  key={index}
                  onPress={() => {
                    setSelectedReason(item);
                    setSelectReasonDropdown(false);
                  }}
                  style={{
                    paddingVertical: 14,
                    paddingHorizontal: 24,
                    backgroundColor: selectedReason === item ? "#374151" : "transparent",
                    borderBottomWidth: index < reasons.length - 1 ? 0.5 : 0,
                    borderBottomColor: "#374151",
                  }}
                >
                  <Text style={{
                    ...AppFontStyle.REGULAR_ANYBODY_14,
                    color: "#FFFFFF",
                    textAlign: "center",
                  }}>
                    {item}
                  </Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          </View>
        )}

        {/* Other reason input */}
        {selectedReason === "Other" && !selectReasonDropdown && (
          <TextInput
            style={{
              ...AppFontStyle.REGULAR_ANYBODY_12,
              color: "#FFFFFF",
              backgroundColor: "#1F2937",
              borderRadius: 8,
              borderWidth: 0.8,
              borderColor: "#374151",
              padding: 12,
              minHeight: 80,
              textAlignVertical: "top",
              marginTop: 12,
            }}
            multiline={true}
            numberOfLines={4}
            placeholderTextColor="#6B7280"
            placeholder="Tell us the reason...."
            value={customReason}
            onChangeText={(text) => setCustomReason(text)}
          />
        )}
      </View>

      {/* Personal message - always show */}
      <View style={{ flex: 1, marginTop: selectReasonDropdown ? 10 : 0 }}>
        <Text style={{
          ...AppFontStyle.BOLD_ANYBODY_16,
          color: "#FFFFFF",
          marginBottom: showMessageError && !message?.trim() ? 4 : 12,
        }}>
          Add a personal message for your audience!
        </Text>
        {showMessageError && !message?.trim() && (
          <Text style={{
            ...AppFontStyle.REGULAR_ANYBODY_12,
            color: "#EF4444",
            marginBottom: 8,
          }}>
            Please enter the message to audience
          </Text>
        )}
        <TextInput
          style={{
            ...AppFontStyle.REGULAR_ANYBODY_12,
            color: "#FFFFFF",
            backgroundColor: "#1F2937",
            borderRadius: 8,
            borderWidth: 0.8,
            borderColor: showMessageError && !message?.trim() ? "#EF4444" : "#374151",
            padding: 12,
            flex: 1,
            minHeight: isMobile ? 100 : 120,
            textAlignVertical: "top",
          }}
          multiline={true}
          numberOfLines={isMobile ? 4 : 5}
          placeholderTextColor="#6B7280"
          placeholder="Tell us the reason...."
          value={message}
          onChangeText={(text) => setMessage(text)}
        />
      </View>
    </View>
  );
};

export default CancelEventReason;
